module.exports = __webpack_public_path__ + "img/roundedArrow.6b4d00fa.svg";